const comments = [
  { id: 1, name: '风之旅人', avatar: '风', time: '2 小时前', content: '《咒术回战》最新话太炸了！芥见下下的分镜永远能给人惊喜，每一页都在挑战我的心脏承受力。樱花动漫之家的更新速度是真的快，每次都是第一个看到的。', likes: 328, tag: '咒术回战' },
  { id: 2, name: '樱花下的猫', avatar: '猫', time: '5 小时前', content: '在樱花动漫之家追《海贼王》已经三年了，从和之国篇到现在的艾尔巴夫篇，每周四的更新就是我的精神食粮。这里的日漫推荐也帮我发现了不少冷门佳作。', likes: 256, tag: '海贼王' },
  { id: 3, name: '二次元老司机', avatar: '司', time: '8 小时前', content: '最近被安利了《坂本日常》，本来以为是普通校园漫，结果打斗场面秒杀一众战斗番。感谢樱花动漫之家的日漫排行推荐，差点错过这部好作品！', likes: 189, tag: '坂本日常' },
  { id: 4, name: '月下独酌', avatar: '月', time: '12 小时前', content: '《葬送的芙莉莲》动画完结后开始补漫画，发现漫画的细腻程度完全不输动画。樱花动漫之家的资源库真的很全，老番新番一应俱全，漫画党狂喜。', likes: 145, tag: '葬送的芙莉莲' },
  { id: 5, name: '漫无止境', avatar: '漫', time: '1 天前', content: '作为追了十几年日漫的老粉，樱花动漫之家这个平台的日漫推荐质量确实高。不是单纯堆热门，而是真的有编辑在用心筛选和点评，小众佳作也能被发现。', likes: 97, tag: '日漫推荐' },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3">
            社区互动
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            漫友热议
          </h2>
          <p className="text-foreground-500 text-sm mt-2">看看大家都在讨论哪些日漫</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {comments.map((comment) => (
            <article key={comment.id} className="bg-background-50 rounded-xl p-5 border border-background-200/70">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-9 h-9 rounded-full bg-primary-100 text-primary-600 flex items-center justify-center text-sm font-bold flex-shrink-0">
                  {comment.avatar}
                </div>
                <div className="min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <h3 className="text-sm font-medium text-foreground-900 whitespace-nowrap">{comment.name}</h3>
                    <span className="text-xs px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 font-medium whitespace-nowrap">{comment.tag}</span>
                  </div>
                  <span className="text-xs text-foreground-400">{comment.time}</span>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed line-clamp-4">
                "{comment.content}"
              </p>
              <div className="mt-3 flex items-center gap-1 text-foreground-400 text-xs">
                <i className="ri-heart-line"></i>
                <span>{comment.likes}</span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}